'use strict';

var d3 = require('d3');

/**
 *
 * @param d3Helper
 * @returns {Function}
 * @constructor
 */
var Curves = function Curves(d3Helper) {
  /**
   * The model object shall contain the following properties:
   *  - fill {String} - color of the curve
   *  - dotted {Boolean} - shall the curve be dotted
   *  - className {string} - css class for the curve
   *
   * @param xPropertyName - a property name used to find X value
   * @param yPropertyName - a property name used to find Y value
   * @param dataPropertyName - a property name used to find data collection
   * @param radius - radius of the point, defaults to 3px
   * @returns {Function}
   * @constructor
   */
  return function (xPropertyName, yPropertyName, dataPropertyName, radius) {
    var params, scales, clipPath;
    var pointRadius = radius || 3;
    var circleFunction = function circleFunction(groupContainer, circlesData, fill) {
      var cssClass = 'circles';
      var selectedCircles = groupContainer.selectAll('circle.' + cssClass).data(circlesData);
      selectedCircles.enter().append('circle');
      selectedCircles.exit().remove();
      selectedCircles.attr({
        'class': function _class(d) {
          return cssClass + (d.css ? ' ' + d.css : '');
        },
        'cx': function cx(d) {
          return scales.xScale(d[xPropertyName]);
        },
        'cy': function cy(d) {
          return scales.yScale(d[yPropertyName]);
        },
        'fill': fill,
        'r': pointRadius
      });
    };

    /**
     *
     * @param container
     * @constructs Curves
     */
    var pointFunc = function pointFunc(container) {
      var shift = scales.xScale.rangeBand ? scales.xScale.rangeBand() / 2 : 0;
      var translate = [shift, 0];
      var tmpDataPropertyName;
      var data;
      if (!dataPropertyName) {
        tmpDataPropertyName = 'curve-' + yPropertyName;
        data = [{}];
        data[0][tmpDataPropertyName] = container.datum();
      } else {
        data = container.datum();
      }
      var pointsGroup = d3Helper.createGroupElement(container, 'group-points');
      if (clipPath) {
        pointsGroup.attr('clip-path', clipPath);
      }
      var points = pointsGroup.selectAll('.points-' + yPropertyName).data(data);
      points.enter().append('g');
      points.exit().remove();
      points.attr({
        'transform': 'translate(' + translate + ')',
        'class': function _class(d) {
          return 'points ' + 'points-' + yPropertyName + (d.className ? ' points-' + d.className : '');
        }
      });
      points.each(function (groupData) {
        var circleData = groupData[dataPropertyName];
        var circleGroup = d3Helper.createGroupElement(d3.select(this), 'circles-group');
        circleFunction(circleGroup, circleData, groupData.fill);
      });
    };

    /**
     * Sets/gets curve's params
     * @param value
     * @returns {pointFunc}
     */
    pointFunc.params = function (value) {
      params = value;
      return pointFunc;
    };

    /**
     * Sets/gets curve's scales
     * @param value
     * @returns {pointFunc}
     */
    pointFunc.scales = function (value) {
      scales = value;
      return pointFunc;
    };
    pointFunc.clipPath = function (value) {
      clipPath = 'url(' + value + ')';
      return pointFunc;
    };
    return pointFunc;
  };
};
Curves.$inject = ['d3Helper'];
module.exports = Curves;